var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReply = function SvgReply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16c-4.376 0-8-3.631-8-8 0-4.376 3.631-8 8.008-8C12.377 0 16 3.624 16 8c0 4.369-3.631 8-8 8Zm-.627-4.722a.47.47 0 0 0 .486-.486V9.176h.125c1.64 0 2.667.408 3.404 1.789a.531.531 0 0 0 .518.313c.22 0 .431-.196.431-.556 0-3.13-1.333-5.051-4.353-5.051H7.86V4.063a.496.496 0 0 0-.494-.51c-.212 0-.345.094-.565.298L3.467 6.965a.595.595 0 0 0-.22.455c0 .14.055.298.22.447L6.8 11.004c.196.18.36.274.573.274Z"
  })));
};
export default SvgReply;